import React, { useState, useRef, useEffect } from 'react';
import '../styles/SearchableSelect.css';
import useDropdownFit from '../utils/useDropdownFit';

function SearchableSelect({ value, onChange, options, placeholder, disabled }) {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const fieldRef = useRef(null);
  const listStyle = useDropdownFit(fieldRef, isOpen && !disabled, { preferred: 250, gap: 0 });

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filter options based on search
  const filtered = (options || []).filter(opt =>
    opt && opt.toString().toLowerCase().includes(search.toLowerCase())
  );

  // Get display value
  const displayValue = options.find(opt => opt === value) || '';

  const handleSelect = (option) => {
    onChange({ target: { value: option } });
    setSearch('');
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    setIsOpen(true);
  };

  const handleInputFocus = () => {
    setIsOpen(true);
  };

  return (
    <div className="searchable-select" ref={containerRef}>
      <div className="select-input-wrapper" ref={fieldRef}>
        <input
          ref={inputRef}
          type="text"
          value={isOpen ? search : displayValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          placeholder={placeholder || 'Search and select...'}
          disabled={disabled}
          className="select-input"
          autoComplete="off"
        />
        <span className="select-arrow">▼</span>
      </div>

      {isOpen && !disabled && (
        <div className={`select-dropdown${listStyle.bottom ? ' select-dropdown--up' : ''}`} style={listStyle}>
          {filtered.length > 0 ? (
            filtered.map((option, idx) => (
              <div
                key={idx}
                className={`select-option ${option === value ? 'selected' : ''}`}
                onClick={() => handleSelect(option)}
              >
                {option}
              </div>
            ))
          ) : (
            <div className="select-option-empty">No matches</div>
          )}
        </div>
      )}
    </div>
  );
}

export default SearchableSelect;
